import TyFileList from './TyFooter.vue'
export default TyFileList



// WEBPACK FOOTER //
// ./src/components/ty-footer/index.js